import i18n from '@/plugins/i18n';

const crashesGraphs = () => ({
  lineCharts: [
    {
      width: '100%',
      isCrashes: true,
      title: i18n.global.t('crashes'),
      header: {
        title: i18n.global.t('crashes'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
        displayOnlyUnit: false,
        displayCustomButton: false,
        customButtonProp: {
          title: '',
        },
      },
      chartColor: ['#98ED78'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      sortOrder: 'DES',
      metricType: 'REGULAR_VALUE',
      metricName: 'mobile_app_crash_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: i18n.global.t('cpmWithFullForm'),
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('noOfCrashesLong'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
    {
      width: '100%',
      title: i18n.global.t('crash-affected-users'),
      header: {
        title: i18n.global.t('crash-affected-users'),
        titleIcon: '',
        content: [],
        displayOnlyUnit: false,
        displayCustomButton: false,
        HideCenterMiscContent: true,
      },
      chartColor: ['#FF8022'],
      height: '12.5em',
      filterType: 'User',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'mobile_app_crash_count',
      queryMetricType: 'readMobileCustomMetricsValues',
      customMetricName: 'crashByFilter',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: i18n.global.t('ms-average'),
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('noOfCrashAffectedUsers'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
  ],
  areaCharts: [
    {
      width: '100%',
      widthInPer: '100%',
      title: i18n.global.t('crashesByOS'),
      height: '12.5em',
      header: {
        title: i18n.global.t('crashesByOS'),
        titleIcon: '',
        content: [],
        toolbar: true,
        HideCenterMiscContent: true,
      },
      chartColor: ['#FF056E', '#FF9520'],
      entityType: 'Endpoint',
      independentSelector: false,
      filterType: 'Os',
      metricType: 'LABELED_VALUE',
      // metricName:
      //   'mobile_app_crash_count,mobile_app_crash_count,browser_app_page_ttfb_avg,browser_app_page_tcp_avg,browser_app_page_trans_avg,browser_app_page_dom_analysis_avg,browser_app_page_fpt_avg,browser_app_page_dom_ready_avg,browser_app_page_load_page_avg,browser_app_page_res_avg,browser_app_page_ssl_avg,browser_app_page_ttl_avg,browser_app_page_first_pack_avg,browser_app_page_fmp_avg',
      metricName:
        'mobile_app_crashes_by_android_percentile,mobile_app_crashes_by_ios_percentile',
      queryMetricType: 'readMobileCustomMetricsValues',
      customMetricName: 'crashByFilter',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: 'ms',
      metricLabels: 'iOS, Android',
      labelsIndex: '0, 1',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('noOfCrashesLong'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
      showLegendForSingle: true,
      responseType: 'dynamic',
    },
  ],

  heatMaps: [
    {
      width: '97.7%',
      title: i18n.global.t('geographicDistribution'),
      header: {
        title: i18n.global.t('geographicDistribution'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: false,
        displayCustomButton: false,
        customButtonProp: {
          title: '',
        },
      },
      chartColor: ['#008FFB'],
      height: '47.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      // metricName: 'browser_app_pv',
      metricName: '',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartBar',
      unit: i18n.global.t('cpmWithFullForm'),
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('numberOfCalls'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
  ],
  areaChartsRight: [
    {
      width: '100%',
      widthInPer: '100%',
      title: i18n.global.t('crashes-by-device-top-5'),
      height: '12.5em',
      filterType: 'Device',
      header: {
        title: i18n.global.t('crashes-by-device-top-5'),
        titleIcon: '',
        content: [],
        toolbar: true,
        HideCenterMiscContent: true,
      },
      chartColor: ['#E63A46', '#F843DD', '#FAB025', '#5DC167', '#00CEFF'],
      entityType: 'Endpoint',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'browser_app_page_resource_error_sum, browser_app_page_js_error_sum, browser_app_page_ajax_error_sum, browser_app_page_unknown_error_sum',
      queryMetricType: 'readMobileCustomMetricsValues',
      customMetricName: 'crashByFilter',
      chartType: 'ApexChartLine',
      unit: 'ms',
      metricLabels: 'Resources, Js, Ajax, Others',
      labelsIndex: '0, 1, 2, 3',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('noOfCrashesLong'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
      showLegendForSingle: true,
      responseType: 'dynamic',
    },
  ],
  areaChartsBottom: [
    {
      width: '100%',
      widthInPer: '100%',
      title: i18n.global.t('crashes-by-app-versions'),
      height: '12.5em',
      filterType: 'AppVersion',
      header: {
        title: i18n.global.t('crashes-by-app-versions'),
        titleIcon: '',
        content: [],
        toolbar: true,
        HideCenterMiscContent: true,
      },
      chartColor: ['#C06FF2', '#4284B0', '#FFDA85', '#3ED093'],
      entityType: 'Endpoint',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'browser_app_page_resource_error_sum, browser_app_page_js_error_sum, browser_app_page_ajax_error_sum, browser_app_page_unknown_error_sum',
      queryMetricType: 'readMobileCustomMetricsValues',
      customMetricName: 'crashByFilter',
      chartType: 'ApexChartLine',
      unit: 'ms',
      metricLabels: 'Resources, Js, Ajax, Others',
      labelsIndex: '0, 1, 2, 3',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('noOfCrashesLong'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
      showLegendForSingle: true,
      responseType: 'dynamic',
    },
  ],
});
export default crashesGraphs;
